import React from "react";
import { Box, Container, Paper, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";

const MembershipAccessDenied: React.FC = () => {
  const { t } = useKivunovaTranslation();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #667eea 0%, #764ba2 25%, #6f49c9 50%, #5b36b0 75%, #4c2a85 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2
      }}
    >
      <Container maxWidth="sm">
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
            {t("membership-access-denied-title", "Subscription access")}
          </Typography>
          <Typography color="text.secondary">
            {t(
              "membership-access-denied-message",
              "Only company administrators can manage subscriptions. Please contact your company admin to subscribe or view subscription details."
            )}
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default MembershipAccessDenied;
